import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    NavigationMenuFeatureDynamicStyleType
} from "./type";
import type {
    Mutable
} from "../../../../types";
import {
    getFocusRingStyle
} from "../../../../helpers/theme/state";
import {
    concentric
} from "../../../../helpers/theme/concentric";
import {
    getCornerStyle
} from "../../../../helpers/theme/corner";
import {
    webStyle
} from "../../../../utils";

export const NAVIGATION_MENU_FEATURE_TITLE_VARIANT: keyof NCoreUIKit.Typography = "titleMediumSize";

export const NAVIGATION_MENU_FEATURE_DESCRIPTION_VARIANT: keyof NCoreUIKit.Typography = "bodyMediumSize";

export const NAVIGATION_MENU_FEATURE_ACTION_VARIANT: keyof NCoreUIKit.Typography = "labelMediumSize";

const stylesheet = StyleSheet.create({
    container: {
        justifyContent: "flex-end",
        flexDirection: "column",
        flexBasis: 0,
        flexGrow: 1,
        minWidth: 0,
        ...webStyle({
            outlineStyle: "solid",
            userSelect: "none",
            outlineWidth: 0
        })
    },
    action: {
        alignItems: "center",
        flexDirection: "row"
    },
    icon: {
        marginBottom: "auto"
    },
    sheetContainer: {
        flexBasis: "auto",
        flexGrow: 0
    }
});

export const getNavigationMenuFeatureRadius = ({
    radiuses,
    borders,
    spaces
}: Pick<NavigationMenuFeatureDynamicStyleType, "radiuses" | "borders" | "spaces">): number => {
    return concentric({
        inset: spaces.spacingXs + borders.line,
        outer: radiuses.surface,
        role: radiuses.surface,
        isCapsuleExempt: false
    });
};

export const useStyles = ({
    isFocusVisible,
    shapeConfigs,
    radiuses,
    borders,
    colors,
    spaces
}: NavigationMenuFeatureDynamicStyleType) => {
    const styles = {
        container: {
            backgroundColor: colors.content.container.subtle,
            ...getCornerStyle({
                radius: getNavigationMenuFeatureRadius({
                    radiuses,
                    borders,
                    spaces
                }),
                shapeConfigs
            }),
            padding: spaces.spacingMd,
            gap: spaces.spacingXs
        } as Mutable<ViewStyle>,
        icon: {
            paddingBottom: spaces.spacingSm
        } as Mutable<ViewStyle>,
        action: {
            paddingTop: spaces.spacingXs,
            gap: spaces.spacingXs
        } as Mutable<ViewStyle>
    };

    Object.assign(styles.container, getFocusRingStyle({
        isFocusVisible,
        isInset: true,
        borders,
        colors
    }));

    return styles;
};
export default stylesheet;
